import PropTypes from 'prop-types';
import styles from './error.module.less';

const Error = ({ error = '', children = null }) =>
    !(error || children) ? null : (
        <div className={styles.errorMessage} role="alert">
            {error || children}
        </div>
    );

Error.propTypes = {
    error: PropTypes.string,
    children: PropTypes.node,
};

export default Error;
